import { render, staticRenderFns } from "./rechargeDetail.vue?vue&type=template&id=12be89ba&scoped=true&"
import script from "./rechargeDetail.vue?vue&type=script&lang=js&"
export * from "./rechargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./rechargeDetail.vue?vue&type=style&index=0&id=12be89ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be89ba",
  null
  
)

export default component.exports